import { LayerDefinition } from './types';

export const dewpointDefinition: LayerDefinition = {
  id: 'dewpoint',
  name: 'Dew Point',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '💧',
  description: '2m Surface Dew Point temperature and atmospheric moisture comfort levels.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'gdps', 'icon13', 'nbm'],
  outputModels: ['Surface Dew Point .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default dewpointDefinition;
